<template>
    <div v-if="0 !== this.amount" class="resource-spec">
        <img v-if="resourceConstant.METAL_RESOURCE === this.type" src="@/assets/img/metal.png" alt="Metal Resource" class="resource-img">
        <img v-if="resourceConstant.CRYSTAL_RESOURCE === this.type" src="@/assets/img/crystal.png" alt="Crystal Resource" class="resource-img">
        <img v-if="resourceConstant.DEUTERIUM_RESOURCE === this.type" src="@/assets/img/deuterium.png" alt="Deuterium Resource" class="resource-img">
        <img v-if="resourceConstant.ENERGY_RESOURCE === this.type" src="@/assets/img/energy.png" alt="Energy Resource" class="resource-img">

        <p :class="statusClass" class="label-xl">{{ this.amount }}</p>
    </div>
</template>

<style scoped>
.resource-spec {
    display: inline-flex;
    height: 40px;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    border-radius: var(--border-radius-xxs);
    background: var(--background-2);
}

.resource-img {
    width: 32px;
}

.text-default {
    color: var(--content-1);
}

.text-positive {
    color: var(--semantic-success);
}

.text-negative {
    color: var(--semantic-danger);
}
</style>

<script>
import * as resourceConstant from '@/constants/resourceConstant';
import * as resourceStyleConstant from '@/constants/resourceStyleClassConstant';

export default {
    name: 'ResourceSpecsComponent',
    setup() {
        return {
            resourceConstant, resourceStyleConstant
        };
    },
    props: {
        status: {
            type: Number,
            default: resourceStyleConstant.DEFAULT_RESOURCE_STYLE,
            validator: (value) => [
                resourceStyleConstant.DEFAULT_RESOURCE_STYLE, 
                resourceStyleConstant.PLUS_RESOURCE_STYLE, 
                resourceStyleConstant.NEGATIVE_RESOURCE_STYLE
            ].includes(value)
        },
        type: {
            type: Number,
            required: true
        },
        amount: {
            type: Number,
            required: true,
            default: 0,
        }
    },
    computed: {
        statusClass() {
            return {
                'text-default': resourceStyleConstant.DEFAULT_RESOURCE_STYLE === this.status,
                'text-positive': resourceStyleConstant.PLUS_RESOURCE_STYLE === this.status,
                'text-negative': resourceStyleConstant.NEGATIVE_RESOURCE_STYLE === this.status
            };
        }
    }
};
</script>